import { httpClient } from '../apiIntegrations/httpClient';
export const getCurrentMerchant = () => {
    return httpClient.get('/merchants/current');
};
